exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Header_header_2z0 {\n  padding: 1em;\n  background: #efefef;\n}\n\n.Header_header_2z0 a {\n  margin-right: 1em;\n}\n", "", {"version":3,"sources":["/./components/Layout/Header.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,oBAAoB;CACrB;;AAED;EACE,kBAAkB;CACnB","file":"Header.css","sourcesContent":[".header {\n  padding: 1em;\n  background: #efefef;\n}\n\n.header a {\n  margin-right: 1em;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"header": "Header_header_2z0"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?{"sourceMap":true,"modules":true,"localIdentName":"[name]_[local]_[hash:base64:3]","minimize":false}!./~/postcss-loader!./components/Layout/Header.css
 ** module id = 542
 ** module chunks = 0
 **/